import { createSelector } from "reselect";

const getPlayingSelector = state => {
  return state.playing.moviesPlaying;
};

export const getPlaying = createSelector(getPlayingSelector, moviesPlaying => {
  return moviesPlaying;
});
